/* biome-ignore-all lint/suspicious/noConsole: Console logging is intentional in this logger implementation */
import type { Logger } from "./Logger";

export class ConsoleLogger implements Logger {
  private bindings: Record<string, unknown> = {};
  info(...messages: unknown[]) {
    console.log(...messages, this.bindings);
  }

  debug(...messages: unknown[]) {
    console.debug(...messages, this.bindings);
  }

  error(error: Error) {
    console.error(error, this.bindings);
  }
  setBindings(bindings: Record<string, unknown>) {
    this.bindings = bindings;
  }
  child(bindings: Record<string, unknown>) {
    const child = new ConsoleLogger();
    child.setBindings({ ...this.bindings, ...bindings });
    return child;
  }
  warn(warn: Error) {
    console.warn(warn, this.bindings);
  }
}
